import type { DocsLocale, DocsSection } from './types'

export const DOCS_SECTIONS: DocsSection[] = [
  { id: 'getting-started', title: 'Getting started', order: 0 },
  { id: 'canvas', title: 'Canvas', order: 1 },
  { id: 'generation', title: 'Generation', order: 2 },
  { id: 'library', title: 'Asset Library', order: 3 },
  { id: 'sets', title: 'Sets', order: 4 },
  { id: 'timeline', title: 'Timeline', order: 5 },
  { id: 'export', title: 'Export', order: 6 },
  { id: 'collaboration', title: 'Collaboration', order: 7 },
  { id: 'teams', title: 'Teams', order: 8 },
  { id: 'account', title: 'Account', order: 9 },
  { id: 'developers', title: 'Developers', order: 10 },
]

export const DOCS_SECTION_MAP = new Map(DOCS_SECTIONS.map(s => [s.id, s]))

const DOCS_SECTION_TRANSLATIONS_JA: Record<string, string> = {
  'getting-started': 'はじめに',
  canvas: 'キャンバス',
  generation: '生成',
  sets: 'セット',
  timeline: 'タイムライン',
  export: '書き出し',
  collaboration: 'コラボレーション',
  teams: 'チーム',
  account: 'アカウント',
  developers: '開発者向け',
}

// Initial LLM-assisted Arabic section labels. Koh reviews these in Phase 6
// before public release.
const DOCS_SECTION_TRANSLATIONS_AR: Record<string, string> = {
  'getting-started': 'البدء',
  canvas: 'الكانفاس',
  generation: 'التوليد',
  sets: 'المجموعات',
  timeline: 'الجدول الزمني',
  export: 'التصدير',
  collaboration: 'التعاون',
  teams: 'الفرق',
  account: 'الحساب',
  developers: 'للمطورين',
}

const DOCS_SECTION_TRANSLATIONS_ES: Record<string, string> = {
  'getting-started': 'Empezar',
  canvas: 'Lienzo',
  generation: 'Generación',
  sets: 'Sets',
  timeline: 'Línea de tiempo',
  export: 'Exportar',
  collaboration: 'Colaboración',
  teams: 'Equipos',
  account: 'Cuenta',
  developers: 'Para desarrolladores',
}

const DOCS_SECTION_TRANSLATIONS_KO: Record<string, string> = {
  'getting-started': '시작하기',
  canvas: '캔버스',
  generation: '생성',
  sets: '세트',
  timeline: '타임라인',
  export: '내보내기',
  collaboration: '협업',
  teams: '팀',
  account: '계정',
  developers: '개발자',
}

const DOCS_SECTION_TRANSLATIONS: Partial<Record<DocsLocale, Record<string, string>>> = {
  ja: DOCS_SECTION_TRANSLATIONS_JA,
  ar: DOCS_SECTION_TRANSLATIONS_AR,
  es: DOCS_SECTION_TRANSLATIONS_ES,
  ko: DOCS_SECTION_TRANSLATIONS_KO,
}

function localizeSection(section: DocsSection, locale: DocsLocale): DocsSection {
  const title = DOCS_SECTION_TRANSLATIONS[locale]?.[section.id]
  return title ? { ...section, title } : section
}

export function getDocsSections(locale: DocsLocale = 'en'): DocsSection[] {
  return DOCS_SECTIONS.map(section => localizeSection(section, locale))
}

export function getSection(id: string, locale: DocsLocale = 'en'): DocsSection | undefined {
  const section = DOCS_SECTION_MAP.get(id)
  return section ? localizeSection(section, locale) : undefined
}
